import { ComposedChart, Bar, Line, XAxis, ResponsiveContainer, Tooltip, CartesianGrid } from 'recharts';

interface TrendBarChartDatum {
  label: string;
  value: number;
}

interface TrendBarChartProps {
  data: TrendBarChartDatum[];
  height?: number;
  valueFormatter?: (value: number) => string;
}

export default function TrendBarChart({ data, height = 220, valueFormatter }: TrendBarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <ComposedChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="oklch(var(--background-200))" />
        <XAxis dataKey="label" tick={{ fontSize: 11, fill: 'oklch(var(--foreground-400))' }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ backgroundColor: 'oklch(var(--background-50))', border: '1px solid oklch(var(--background-200))', borderRadius: '12px', fontSize: '13px' }}
          formatter={(value: number) => [valueFormatter ? valueFormatter(value) : value, undefined]}
        />
        <Bar dataKey="value" fill="oklch(var(--primary-200))" radius={[6, 6, 6, 6]} barSize={22} />
        <Line type="monotone" dataKey="value" stroke="oklch(var(--primary-600))" strokeWidth={2} strokeDasharray="4 3" dot={{ r: 3, fill: 'oklch(var(--primary-600))' }} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
